import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-listing-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "listing-lib-calendar-ui-mode" */'./ListingLibCalendarLayout').then(mod => mod.default).catch(AsyncComponentErrorHandler('listing-lib-calendar-ui-mode')),
  LoadingComponent: () => null
});